import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { Popover } from 'antd';
import { SvgIcon } from '@/components';

import {
  type ConnectionsSegmentMode,
  CONNECTIONS_SEGMENT_OPTIONS,
} from './CounterpartyConnections.helpers';

import styles from './CounterpartyConnections.module.sass';

export const COUNTERPARTY_CONNECTIONS_POPOVER_BODY_STYLES = {
  body: { padding: 0 },
};

export type CounterpartyConnectionsToolbarProps = {
  headingId: string;
  segment: ConnectionsSegmentMode;
  onSegmentChange: (mode: ConnectionsSegmentMode) => void;
  filterOpen: boolean;
  onFilterOpenChange: (open: boolean) => void;
  filterPanelActive: boolean;
  filterContent: ReactNode;
};

export function CounterpartyConnectionsToolbar({
  headingId,
  segment,
  onSegmentChange,
  filterOpen,
  onFilterOpenChange,
  filterPanelActive,
  filterContent,
}: CounterpartyConnectionsToolbarProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.toolbar}>
      <div
        className={styles.segmented}
        role="group"
        aria-labelledby={headingId}
      >
        {CONNECTIONS_SEGMENT_OPTIONS.map(({ mode, translationKey }) => (
          <button
            key={mode}
            type="button"
            className={cx(styles.segment, {
              [styles.segmentActive]: segment === mode,
            })}
            aria-pressed={segment === mode}
            onClick={() => onSegmentChange(mode)}
          >
            {t(translationKey)}
          </button>
        ))}
      </div>
      <Popover
        trigger="click"
        placement="bottomRight"
        open={filterOpen}
        onOpenChange={onFilterOpenChange}
        styles={COUNTERPARTY_CONNECTIONS_POPOVER_BODY_STYLES}
        content={filterContent}
      >
        <button
          type="button"
          className={cx(styles.filterBtn, {
            [styles.filterBtnActive]: filterPanelActive,
          })}
          aria-expanded={filterOpen}
        >
          <SvgIcon name="filter" className={styles.filterIcon} />
          <span className={styles.filterLabel}>
            {t('translation.connections_filter')}
          </span>
          {filterPanelActive ? (
            <span className={styles.filterActiveDot} aria-hidden />
          ) : null}
        </button>
      </Popover>
    </div>
  );
}
